"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var PROGRESS_TYPES = [{
  type: 'reviews',
  label: 'Delete All Reviews',
  onlyForGerman: false,
  warning: typeof navigator !== 'undefined' && navigator.product === 'ReactNative' ? 'This will delete all your review cards. To keep them and only reset progress, use "Reset Deck" in a review deck.' : 'This will delete all your review cards for the current language. To keep them and only reset progress, use "Reset Deck" in a review deck.'
}, {
  type: 'stories',
  label: 'Stories',
  onlyForGerman: false
}, {
  type: 'vocab',
  label: 'Vocabulary Trainer',
  onlyForGerman: false
}, {
  type: 'gender',
  label: 'Gender Trainer',
  onlyForGerman: false
}, {
  type: 'plural',
  label: 'Plural Trainer',
  onlyForGerman: true
}, {
  type: 'number',
  label: 'Number Trainer',
  onlyForGerman: false
}, {
  type: 'conjugation',
  label: 'Conjugation Trainer',
  onlyForGerman: false
}, {
  type: 'synonyms',
  label: 'Synonym Trainer',
  onlyForGerman: false
}, {
  type: 'case',
  label: 'Case Trainer',
  onlyForGerman: true
}, {
  type: 'trivia',
  label: 'Trivia',
  onlyForGerman: false
}, {
  type: 'league',
  label: 'League',
  onlyForGerman: false,
  warning: 'Clearing League progress affects all languages.'
}];
var SettingsClearProgressWrapper = function SettingsClearProgressWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "isTypeSelected", _descriptor, _this);
      _initializerDefineProperty(_this, "clearingProgressTypes", _descriptor2, _this);
      _initializerDefineProperty(_this, "message", _descriptor3, _this);
      _initializerDefineProperty(_this, "showMessage", _descriptor4, _this);
      _initializerDefineProperty(_this, "showSpinner", _descriptor5, _this);
      _this.toggleType = function (type) {
        _this.isTypeSelected[type] = !_this.isTypeSelected[type];
      };
      _this.clearProgress = function () {
        if (!_this.hasSelection || _this.showSpinner) return;
        _this.showSpinner = true;
        _this.clearingProgressTypes = _this.selectedProgressTypes;
        _this.clearSelectedTypes();
      };
      _this.clearSelectedTypes = function () {
        _state.AppUI.authUserStore.clearProgress({
          data: {
            language_id: _state.AppUI.targetLanguageId,
            types: _this.clearingProgressTypes.map(function (_ref) {
              var type = _ref.type;
              return type;
            })
          },
          failureCallback: _this.onClearFailure
        }, _this.afterClearProgress);
      };
      _this.afterClearProgress = function () {
        _this.afterClearSelectedType();
        _this.afterClearDone();
      };
      _this.afterClearDone = function () {
        PROGRESS_TYPES.forEach(function (_ref2) {
          var type = _ref2.type;
          _this.isTypeSelected[type] = false;
        });
        _this.showSpinner = false;
        _this.message = _this.formatClearedTypesMessage(_this.clearingProgressTypes);
        _this.showMessage = true;
        setTimeout(function () {
          return _this.showMessage = false;
        }, 3000);
        _this.clearingProgressTypes = [];
      };
      _this.formatClearedTypesMessage = function (clearedTypes) {
        if (!clearedTypes || clearedTypes.length === 0) {
          return 'Progress cleared';
        }
        var labels = clearedTypes.map(function (_ref3) {
          var type = _ref3.type,
            label = _ref3.label;
          return type === 'reviews' ? 'Reviews' : label;
        });
        if (labels.length === 1) {
          return "".concat(labels[0], " Progress Cleared");
        }
        if (labels.length === 2) {
          return "".concat(labels[0], " and ").concat(labels[1], " Progress Cleared");
        }
        return "".concat(labels.slice(0, -1).join(', '), " and ").concat(labels[labels.length - 1], " Progress Cleared");
      };
      _this.afterClearSelectedType = function () {
        var selectedTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.clearingProgressTypes;
        _state.AppUI.loadUser(_this.afterLoadUserForClear.bind(_this, selectedTypes), {
          forceRefresh: true,
          failureCallback: _this.onClearFailure
        });
      };
      _this.afterLoadUserForClear = function (selectedTypes) {
        var selectedStoriesOrTrivia = _this.selectedHasType('stories', selectedTypes) || _this.selectedHasType('trivia', selectedTypes);
        var selectedReviews = _this.selectedHasType('reviews', selectedTypes);
        if (selectedStoriesOrTrivia && _state.AppUI.targetLanguageId && _state.AppUI.targetLanguageId !== 'undefined') {
          _state.TreeUI.clearTrees();
          _state.TreeUI.loadTreesFromTargetLanguage(_state.AppUI.targetLanguageId);
        }
        if (selectedReviews) {
          _state.AppUI.loadReviewDecks();
        }
      };
      _this.selectedHasType = function (type) {
        var selectedTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.clearingProgressTypes;
        return selectedTypes.some(function (item) {
          return item.type === type;
        });
      };
      _this.onClearFailure = function () {
        _this.showSpinner = false;
      };
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "introText",
      get: function get() {
        if (_state.AppUI.targetLanguageName) {
          return "Select the progress you want to reset for ".concat(_state.AppUI.targetLanguageName, ", then click the button below.");
        }
        return 'Select the progress you want to reset for your currently selected language, then click the button below.';
      }
    }, {
      key: "visibleProgressTypes",
      get: function get() {
        return PROGRESS_TYPES.filter(function (config) {
          return !config.onlyForGerman || _state.AppUI.targetLanguageId === 'DE';
        });
      }
    }, {
      key: "hasSelection",
      get: function get() {
        return this.selectedProgressTypes.length > 0;
      }
    }, {
      key: "selectedWarnings",
      get: function get() {
        var _this2 = this;
        return this.visibleProgressTypes.filter(function (_ref4) {
          var type = _ref4.type,
            warning = _ref4.warning;
          return _this2.isTypeSelected[type] && warning;
        }).map(function (_ref5) {
          var warning = _ref5.warning;
          return warning;
        });
      }
    }, {
      key: "selectedProgressTypes",
      get: function get() {
        var _this3 = this;
        return this.visibleProgressTypes.filter(function (_ref6) {
          var type = _ref6.type;
          return _this3.isTypeSelected[type];
        });
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({
          introText: this.introText,
          progressTypes: this.visibleProgressTypes,
          selectedTypes: this.isTypeSelected,
          selectedWarnings: this.selectedWarnings,
          hasSelection: this.hasSelection,
          toggleType: this.toggleType,
          clearProgress: this.clearProgress,
          message: this.message,
          showMessage: this.showMessage,
          showSpinner: this.showSpinner
        }, this.props));
      }
    }]);
  }(_react["default"].Component), _applyDecoratedDescriptor(_class2.prototype, "introText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "introText"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "isTypeSelected", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return PROGRESS_TYPES.reduce(function (acc, _ref7) {
        var type = _ref7.type;
        acc[type] = false;
        return acc;
      }, {});
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "clearingProgressTypes", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return [];
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "message", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "showMessage", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "showSpinner", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "visibleProgressTypes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "visibleProgressTypes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasSelection", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasSelection"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectedWarnings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedWarnings"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectedProgressTypes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedProgressTypes"), _class2.prototype), _class2)) || _class;
};
SettingsClearProgressWrapper.displayName = 'SettingsClearProgressWrapper';
var _default = exports["default"] = SettingsClearProgressWrapper;